import { useState } from 'react';
import DayCell from './DayCell';
import ScheduleModal from './ScheduleModal';
import clsx from 'clsx';
import { saveEmployeeSchedule } from '../api/scheduleApi';

export default function EmployeeRow({
  employee,
  days,
  hideWeekend,
  minByDow,
  schedule,
  headCountByDate,
  businessId,
  offMap,
  rowStatus = 'ok',      // 'under' | 'ok' | 'over'
  daysOffWarn = false,
}) {
  const [modalInfo, setModalInfo] = useState(null);

  const baseRowColour =
    rowStatus === 'under'
      ? 'bg-red-50'
      : rowStatus === 'over'
      ? 'bg-yellow-50'
      : 'bg-green-50';
  const removeShift = async (date, idx) => {
    const iso        = date.format('YYYY-MM-DD');
    const current    = schedule?.[iso] || [];
    const newShifts  = current.filter((_, i) => i !== idx);   // drop one

    try {
      await saveEmployeeSchedule(businessId, {
        employee_id: employee.id,
        schedule   : { [iso]: newShifts },   // overwrite that day
      });
      window.dispatchEvent(new Event('schedule-updated'));
    } catch (e) {
      alert('Failed to delete shift');
      console.error(e);
    }
  };
  return (
    <>
      <div
        className={clsx('grid', baseRowColour)}
        style={{ gridTemplateColumns: `200px repeat(${days.length}, 1fr)` }}
      >
        {/* employee label */}
        <div
          className={clsx(
            'border-r px-2 py-2 flex items-center space-x-2',
            baseRowColour,                          // keep hours-based colour
            daysOffWarn && 'border-l-4 border-red-500'  // subtle warning
          )}
        >
          <img
            src={employee.picture_url}
            alt=""
            className="w-6 h-6 rounded-full object-cover"
          />
          <span className="text-sm">{employee.full_name}</span>

          {daysOffWarn && (
            <span className="ml-auto px-1 text-[10px] rounded bg-red-500 text-white">
              Few days-off
            </span>
          )}
        </div>

        {/* day cells */}
        {days.map((date) => {
          const weekend = date.day() === 0 || date.day() === 6;
          if (hideWeekend && weekend) return null;

          const isoDow = date.day() === 0 ? 7 : date.day(); // Mon = 1
          return (
            <DayCell
              key={date.toString()}
              date={date}
              employee={employee}
              onAddShift={() => setModalInfo({ date })}
              minRequired={minByDow[isoDow] ?? 0}
              shifts={schedule?.[date.format('YYYY-MM-DD')] || []}
              employeesScheduled={
                headCountByDate[date.format('YYYY-MM-DD')] || 0
              }
              offMap={offMap}
              onRemoveShift={(idx) => removeShift(date, idx)}
            />
          );
        })}
      </div>

      {/* modal */}
      {modalInfo && (
        <ScheduleModal
          employee={employee}
          date={modalInfo.date}
          onClose={() => setModalInfo(null)}
          businessId={businessId}
        />
      )}
    </>
  );
}
